/**
 * Which front end build this is. The back end serves both from the same
 * origin (the legacy build at the root of wwwroot, the new one in `next`) and
 * picks one from the `ox_ui` cookie — see UiVersionService for the switch.
 *
 * This constant is the only thing that differs between the two branches.
 */
export type UiVersion = 'legacy' | 'next';

export const UI_VERSION: UiVersion = 'legacy';
